export const itemAllColumns = [
  {id: 'item', label: 'Question'},
  {id: 'questionType', label: 'Question Type', minWidth: 160},
  {id: 'actions', label: ''},
];
